/*
 * @Author       : Lobin
 * @Date         : 2020-12-01 10:08:38
 * @LastEditors  : Lobin
 * @Description  : 
 * @LastEditTime : 2021-07-27 22:59:03
 */
import Vue from "vue";
// import fastClick from 'fastclick';
import VConsole from "vconsole/dist/vconsole.min.js";
import "./utils/htmlFontSize";
import "./components/index.js";
import "./styles/index.scss";
import App from "./App.vue";
import router from "./router";
import gMixins from "@/mixins";
import store from "./store";
// fast click
// fastClick.attach(document.body);

const isProduction = process.env.NODE_ENV === "production";
Vue.config.productionTip = false;

if (!isProduction) {
  new VConsole();
}

Vue.mixin(gMixins);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
